var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"section-shape",attrs:{"viewBox":"0 23 500 32","preserveAspectRatio":"none"}},[_c('path',{attrs:{"d":"M-237.97,103.13 C201.53,-102.13 318.14,183.05 741.62,-36.02 L655.95,547.25 L-381.89,482.11 Z","stroke":"none","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }